/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this file will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


    /* JS FOR PRODUCT IMAGE SLIDER */

document.addEventListener("DOMContentLoaded", function () {
  // Only run on mobile
  if (window.innerWidth > 768) return;

  const sliderWrapper = document.querySelector('product-images.product__images--mobile-slider');
  if (!sliderWrapper) return;

  const scrollContainer = sliderWrapper.querySelector('.product__slides');
  if (!scrollContainer) return;

  // Inject progress bar if it doesn't exist
  if (!sliderWrapper.nextElementSibling?.classList?.contains('mobile-slider-progress')) {
    const progressBarWrapper = document.createElement('div');
    progressBarWrapper.className = 'mobile-slider-progress';
    progressBarWrapper.innerHTML = '<div class="mobile-slider-progress__bar"></div>';
    sliderWrapper.insertAdjacentElement('afterend', progressBarWrapper);
  }

  const progressBar = document.querySelector('.mobile-slider-progress__bar');

  function updateProgressBar() {
    const scrollLeft = scrollContainer.scrollLeft;
    const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
    const percent = (scrollLeft / maxScroll) * 100;
    progressBar.style.width = `${percent}%`;
  }

  scrollContainer.addEventListener('scroll', updateProgressBar, { passive: true });
  updateProgressBar();
});

document.addEventListener('DOMContentLoaded', function() {
  function updateClocks() {
    const options = { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false };

    const nyElement = document.getElementById('time-ny');
    const lonElement = document.getElementById('time-lon');
    const sydElement = document.getElementById('time-syd');

    if (nyElement) {
      nyElement.textContent = new Date().toLocaleTimeString('en-US', { ...options, timeZone: 'America/New_York' });
    }
    if (lonElement) {
      lonElement.textContent = new Date().toLocaleTimeString('en-GB', { ...options, timeZone: 'Europe/London' });
    }
    if (sydElement) {
      sydElement.textContent = new Date().toLocaleTimeString('en-AU', { ...options, timeZone: 'Australia/Sydney' });
    }
  }

  setInterval(updateClocks, 1000);
  updateClocks();
});


// BOF HIDING AND SELECTING OPTIONS ON PRODUCT PAGE //

(function () {
  const SCOPE_SEL = '.product__selectors';
 
  // colour (option1) -> [materials (option2) that exist as a real variant]
  let optionMap = null;
  (function buildOptionMap() {
    if (!/\/products\//.test(location.pathname)) { optionMap = {}; return; }
    fetch(location.pathname.replace(/[?#].*$/, '') + '.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((p) => {
        const map = {};
        (p.variants || []).forEach((v) => {
          const colour = v.options[0];
          const material = v.options[1];
          if (material == null) return; // single-option product
          (map[colour] = map[colour] || []).push(material);
        });
        optionMap = map;
      })
      .catch(() => { optionMap = {}; });
  })();
 
  // CAPTURE phase: correct the material BEFORE Broadcast resolves the variant,
  // then re-fire a change so the whole UI refreshes for the resolved variant.
  document.addEventListener('change', function (event) {
    const input = event.target;
    if (!input || !input.matches || !input.matches(`${SCOPE_SEL} input[data-index="option1"]`)) return;
    const selectors = input.closest(SCOPE_SEL);
    if (!selectors) return;
 
    const option2 = Array.from(
      selectors.querySelectorAll('.selector-wrapper[data-option-position="2"] input[data-index="option2"]')
    );
    if (!option2.length) return; // single-option product — nothing to do
 
    const materials = optionMap ? optionMap[input.value] : null;
    let target = option2.find((i) => i.checked);
 
    // If the current material isn't valid for this colour, switch to one that is.
    if (materials && (!target || !materials.includes(target.value))) {
      const valid = option2.find((i) => materials.includes(i.value));
      if (valid) {
        valid.checked = true; // silent: prevents the null-variant crash
        target = valid;
      }
    }
 
    // Re-fire a clean change on the correct material after Broadcast's own
    // handler runs, so price / image / Add-to-cart (incl. Sold Out) all refresh.
    if (target) {
      requestAnimationFrame(() => target.dispatchEvent(new Event('change', { bubbles: true })));
    }
  }, true);
 
  // Mark interacted on first selection so colour strikes only show after a choice.
  document.addEventListener('change', function (event) {
    if (
      event.target.matches(`${SCOPE_SEL} input[data-index="option1"]`) ||
      event.target.matches(`${SCOPE_SEL} input[data-index="option2"]`)
    ) {
      const selectors = event.target.closest(SCOPE_SEL);
      if (selectors) selectors.classList.add('variant-interacted');
    }
  });
})();


// EOF HIDING AND SELECTING OPTIONS ON PRODUCT PAGE //

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
